import { z } from "zod";

export const marketplaceSearchSchema = z.object({
  query: z.string().optional(),
  type: z.enum(["all", "songs", "beats", "soundkits"]).optional(),

  genre: z.string().optional(),
  mood: z.string().optional(),
  key: z.string().optional(),
  bpm: z.string().optional(),
  types: z.string().optional(),

  year: z.string().optional(),
  vocals: z.string().optional(),

  sort: z
    .enum([
      "discover",
      "new-releases",
      "most-popular",
      "price-asc",
      "price-desc",
    ])
    .optional(),
});

export type MarketplaceSearch = z.infer<typeof marketplaceSearchSchema>;
